import React, {Component} from 'react';
import StepZilla from 'react-stepzilla';
import FirstStep from './FirstStep';
import AddressStep from './AddressStep';
import FinalStep from './FinalStep';
import withUserInfo from '../../hoc/withUserInfo';
import {Modal} from 'react-bootstrap';

import './AddAccount.scss';
class AddAccount extends Component {

    constructor(props) {
        super(props)
        this.handleAccountCreated = this
            .handleAccountCreated
            .bind(this);
        this.handleGetUserRegistrationInfo = this
            .handleGetUserRegistrationInfo
            .bind(this);

        this.onStepSubmited = this
            .onStepSubmited
            .bind(this);

        this.onStepChangeHandler = this
            .onStepChangeHandler
            .bind(this);

        this.handleClose = this
            .handleClose
            .bind(this);

        this.state = {
            accountCreated: false,
            show: true,
            currentStep: 0,
            formValues: {
                accountNumber: ''
            },
            stepValues: [],
            IsSsnAssociated: null
        }
    }

    handleClose() {
        if (this.props.onClose) {

            this
                .props
                .onClose(this.state.accountCreated);
        }

    }

    onStepChangeHandler(stepIndex) {

        this.setState({currentStep: stepIndex});
    }

    async onStepSubmited(step, values) {

        const stepObj = {};
        stepObj[step] = values;

        this.setState({
            formValues: {
                ...this.state.formValues,
                ...values
            },
            stepValues: Object.assign([...this.state.stepValues], stepObj)

        });

    }

    handleGetUserRegistrationInfo(regInfo) {
        this.setState({IsSsnAssociated: regInfo.IsSsnAssociated});
    }

    handleAccountCreated() {
        this.setState({accountCreated: true});
    }

    render() {

        const steps = [
            {
                name: 'Account',
                component: <FirstStep
                        onSubmited={this.onStepSubmited}
                        login={this.props.login}
                        userId={this.props.user
                        ? this.props.user.userId
                        : ''}
                        onGetUserRegistrationInfo={this.handleGetUserRegistrationInfo}
                        stepValues={this.state.stepValues[1]}/>
            }, {
                name: 'Verification',
                component: <AddressStep
                        onSubmited={this.onStepSubmited}
                        requiredSSN={this.state.IsSsnAssociated}
                        accountNumber={this.state.formValues.accountNumber}
                        onAccountCreated={this.handleAccountCreated}
                        login={this.props.login}
                        userId={this.props.user
                        ? this.props.user.userId
                        : ''}
                        stepValues={this.state.stepValues[2]}/>
            }, {
                name: 'Done',
                component: <FinalStep onClose={this.handleClose}/>
            }
        ];
        return (

            <div className="modal-dialog">
                <Modal onHide={this.handleClose} keyboard={false} backdrop="static" show>

                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.title}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className='userRegistration '>
                            <h4>Add Linked Account{this.state.formValues.accountNumber && this.state.currentStep
                                    ? ': ' + this.state.formValues.accountNumber
                                    : null}</h4>
                            <div className='step-progress'>
                                <StepZilla
                                    stepsNavigation={false}
                                    showSteps={true}
                                    prevBtnOnLastStep={false}
                                    nextTextOnFinalActionStep='Submit'
                                    onStepChange={this.onStepChangeHandler}
                                    steps={steps}/>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer></Modal.Footer>

                </Modal>

            </div>

        )
    }
}
export default withUserInfo(AddAccount);
